// = Libs =
import { FC } from 'react';
import { IconProps } from '@/common/components/icons/icon.types';

// = Constants =
import COLORS from '@/constants/colors';

const GlobeIcon: FC<IconProps> = ({ color = 'dark' }) => {
  const iconColor = COLORS[color];

  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9556 25.9111C21.0062 25.9111 25.9111 21.0062 25.9111 14.9556M14.9556 25.9111C8.90497 25.9111 4 21.0062 4 14.9556M14.9556 25.9111C17.6959 22.9111 19.2532 19.0179 19.3378 14.9556C19.2532 10.8933 17.6959 7.00002 14.9556 4M14.9556 25.9111C12.2153 22.9111 10.658 19.0179 10.5734 14.9556C10.658 10.8933 12.2153 7.00002 14.9556 4M25.9111 14.9556C25.9111 8.90497 21.0062 4 14.9556 4M25.9111 14.9556H4M14.9556 4C8.90497 4 4 8.90497 4 14.9556"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GlobeIcon;
